import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Twitter } from 'lucide-react';

const Footer4 = () => {
    const navigate = useNavigate();

    const footerLinks = {
        shop: [
            { label: 'Silk Sarees', path: '/template4/shop' },
            { label: 'Lehengas', path: '/template4/shop' },
            { label: 'Kurtas', path: '/template4/shop' },
            { label: 'Dupattas', path: '/template4/shop' },
            { label: 'Bridal Wear', path: '/template4/shop' },
        ],
        company: [
            { label: 'About Us', path: '/template4/about' },
            { label: 'Contact', path: '/template4/contact' },
            { label: 'FAQs', path: '/template4/faqs' },
        ],
        policies: [
            { label: 'Shipping & Exchange', path: '/template4/shipping' },
            { label: 'Privacy Policy', path: '/template4/privacy' },
            { label: 'Terms & Conditions', path: '/template4/terms' },
        ],
    };

    return (
        <footer className="bg-[#1B4965] text-white" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                {/* Mobile: stacked, Desktop: 4-col */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                    {/* Brand Column */}
                    <div>
                        <h3
                            className="text-xl md:text-2xl font-bold tracking-wider mb-4 cursor-pointer"
                            onClick={() => navigate('/template4')}
                        >
                            NEELA
                        </h3>
                        <p className="text-sm text-white/60 leading-relaxed mb-6">
                            Celebrating the art of Indian fashion with handcrafted elegance. Each piece tells a story of heritage and modern sophistication.
                        </p>
                        <div className="flex gap-4">
                            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#62B6CB] flex items-center justify-center transition-colors duration-300">
                                <Instagram size={16} />
                            </a>
                            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#62B6CB] flex items-center justify-center transition-colors duration-300">
                                <Facebook size={16} />
                            </a>
                            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#62B6CB] flex items-center justify-center transition-colors duration-300">
                                <Twitter size={16} />
                            </a>
                        </div>
                    </div>

                    {/* Shop Links */}
                    <div>
                        <h4 className="text-sm font-semibold tracking-wider uppercase mb-4 text-[#62B6CB]">
                            Shop
                        </h4>
                        <ul className="space-y-2.5">
                            {footerLinks.shop.map((link) => (
                                <li key={link.label}>
                                    <button
                                        onClick={() => navigate(link.path)}
                                        className="text-sm text-white/60 hover:text-white transition-colors duration-300 bg-transparent border-none cursor-pointer p-0"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company Links */}
                    <div>
                        <h4 className="text-sm font-semibold tracking-wider uppercase mb-4 text-[#62B6CB]">
                            Company
                        </h4>
                        <ul className="space-y-2.5">
                            {footerLinks.company.map((link) => (
                                <li key={link.label}>
                                    <button
                                        onClick={() => navigate(link.path)}
                                        className="text-sm text-white/60 hover:text-white transition-colors duration-300 bg-transparent border-none cursor-pointer p-0"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Policies Links */}
                    <div>
                        <h4 className="text-sm font-semibold tracking-wider uppercase mb-4 text-[#62B6CB]">
                            Policies
                        </h4>
                        <ul className="space-y-2.5">
                            {footerLinks.policies.map((link) => (
                                <li key={link.label}>
                                    <button
                                        onClick={() => navigate(link.path)}
                                        className="text-sm text-white/60 hover:text-white transition-colors duration-300 bg-transparent border-none cursor-pointer p-0"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-white/40">
                        &copy; {new Date().getFullYear()} NEELA. All rights reserved.
                    </p>
                    <p className="text-xs text-white/40">
                        Crafted with love in India
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer4;
